/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. **/
import React from 'react'
import classNames from 'classnames'


class Icon extends React.PureComponent {
  render () {
    const { className, svgRef, ...otherProps } = this.props
    return (
      <svg width="30px" height="30px" viewBox="0 0 30 30" version="1.1" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
    <path d="M0,15A15,15,0,1,0,15,0,15,15,0,0,0,0,15Z" transform="translate(0 0)" className="icon-fill"/><g>
      <polygon points="8.18 21.8 11.53 21.8 11.53 11.81 8.18 11.81 8.18 21.8" style={{fill: "#fff"}}/>
      <g>
        <path d="M9.86,10.45h0A1.73,1.73,0,1,1,9.88,7a1.73,1.73,0,1,1,0,3.45" transform="translate(0 0)" style={{fill: "#fff"}}/>
        <path d="M23.49,21.8h-3.3V16.47c0-1.35-.49-2.26-1.69-2.26a1.82,1.82,0,0,0-1.71,1.21,2.23,2.23,0,0,0-.12.81V21.8H13.36s0-9.06,0-10h3.31v1.42a3.3,3.3,0,0,1,3-1.65c2.18,0,3.82,1.43,3.82,4.5Z" transform="translate(0 0)" style={{fill: "#fff"}}/>
      </g>
    </g>
</svg>
    )
  }
}

Icon.displayName = 'LinkedinIcon'

export default Icon
